import { formatDuration as formatDurationDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

type FormatDurationProps = {
    seconds: number;
}

export const formatDuration = ({ seconds }: FormatDurationProps): string =>
    formatDurationDiagram(seconds);
